<!--  -->
<template>
  <div class="shownew">
      <ul class="left" >
        <li class="title">测评服务</li>
        <template v-if="articles && articles.length > 0">
          <li class="item" v-for="(article, index) in articles" :key="index" >    
            <img :src="`${ global.remoteIp }/uploads/${ article.picsrc }`" alt="" width="344" height="262">
          <router-link tag="p" :to="`/views/info/${article.plateid}/${article._id}`">
          {{ article.title }}</router-link> 
          <span>{{ article.addtime | dateFormat }}</span>  
          </li>
        </template>
      </ul>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  filters: {
    dateFormat: function (date) {
      return date?date.substring(0,10):""
    }
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="测评服务"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=3&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
        }
    });
  }
}
</script>
<style scoped>
.shownew{
  width: 1200px !important;
  margin: 64px auto 0;
  height: 560px;
}
.left{
  height: 560px;
  width: 1200px;
  background-image: url(/static/img/honglan.png);
background-repeat: no-repeat;
background-size: 10px 41px;
background-position: left top;
 display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.left .title{
  margin-bottom: 32px;
  box-sizing: border-box;
  width: 1200px;
  height: 41px;
  margin-left:27px;
font-size: 28px;
font-family: PingFang SC;
font-weight: bold;
color: #4462CF;
line-height: 28px;
border-bottom:1px solid #EEEEEF;
}
.left .item{
  position: relative;
  width: 380px;
height: 437px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px rgba(228,210,210,0.35);
border-radius: 20px;
display: flex;
flex-direction: column;
justify-content: start;
align-items: center;
}
.left .item img{
  margin-top: 17px;
  border-radius: 20px;
}
.left .item p{
   margin-top: 39px;
  width: 346px;
height: 46px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
line-height: 25px;
overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.left .item span{
  margin-top: 36px;
  width: 346px;
height: 16px;
font-size: 16px;
font-family: PingFang SC;
color: #666666;
line-height: 16px;
}
</style>